import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const items = [
  {
    q: "Qual o horário de atendimento?",
    a: "Atendemos 24 horas por dia, todos os dias da semana — inclusive feriados, finais de semana e madrugadas. Sua mensagem no WhatsApp é respondida imediatamente, a qualquer hora.",
  },
  {
    q: "Vocês entregam na Zona Sul, Zona Norte e Centro do Rio de Janeiro?",
    a: "Sim. Entregamos coroas de flores em toda a Zona Sul (Botafogo, Copacabana, Ipanema, Leblon, Flamengo, Laranjeiras, Urca, Humaitá, Jardim Botânico, Gávea, São Conrado, Leme, Cosme Velho, Catete, Glória, Vidigal), Zona Norte (Tijuca, Méier, São Cristóvão, Vila Isabel, Grajaú) e Centro (Centro, Lapa, Santa Teresa, Cidade Nova).",
  },
  {
    q: "Quais cemitérios vocês atendem?",
    a: "Entregamos no Cemitério São João Batista (Botafogo), Cemitério do Caju, Cemitério Memorial do Carmo, Cemitério do Catumbi, Cemitério da Penitência, Crematório do Rio de Janeiro e demais cemitérios do município do Rio de Janeiro. Confirme o endereço pelo WhatsApp antes de finalizar o pedido.",
  },
  {
    q: "A entrega é grátis?",
    a: "Sim, a entrega é grátis para toda a Zona Sul, Zona Norte e Centro do Rio de Janeiro. Sem taxa adicional em nenhum cemitério ou velório da nossa área de cobertura.",
  },
  {
    q: "Como personalizar a faixa de homenagem?",
    a: "A faixa de homenagem é gratuita e inclusa em todos os modelos. Basta nos enviar pelo WhatsApp a mensagem desejada — nome do(a) homenageado(a), assinatura da família ou texto livre — ao confirmar o pedido.",
  },
  {
    q: "Quais formas de pagamento são aceitas?",
    a: "Aceitamos PIX (com confirmação imediata), cartão de crédito, cartão de débito e dinheiro na entrega. As condições são confirmadas com nossa equipe pelo WhatsApp.",
  },
  {
    q: "Como faço o pedido pelo WhatsApp?",
    a: "Basta clicar em qualquer botão verde do site 'Pedir pelo WhatsApp' ou enviar mensagem diretamente para (21) 96674-8595. Nossa equipe atende em poucos minutos, 24 horas por dia, e envia a foto da coroa pronta antes da entrega.",
  },
  {
    q: "Vocês enviam foto antes da entrega?",
    a: "Sim. Enviamos uma foto da coroa pronta antes da saída para entrega — você aprova e seguimos para o local indicado.",
  },
  {
    q: "Posso agendar o pedido para outro dia?",
    a: "Sim. Agendamos a entrega no dia e horário que precisar — desde missas de 7º dia até cerimônias futuras.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="py-20 md:py-28">
      <div className="container-wide grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <span className="overline">Dúvidas frequentes</span>
          <h2 className="text-4xl md:text-5xl font-semibold text-[#2D4A3E] leading-tight mt-3 tracking-tight">
            Perguntas que recebemos com frequência
          </h2>
          <p className="mt-4 text-[#5C5C5C] leading-relaxed">
            Caso reste alguma dúvida, fale conosco diretamente pelo WhatsApp — atendemos 24 horas.
          </p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="space-y-3">
            {items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border border-[#E5E3DB] rounded-xl bg-white px-5 data-[state=open]:border-[#2D4A3E]"
              >
                <AccordionTrigger className="text-left font-medium text-lg text-[#2D4A3E] hover:no-underline">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#5C5C5C] text-sm leading-relaxed">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
